(function (ws) {
    'use strict';

    ws.collections.cartPageCollection = Backbone.Collection.extend({

        /**
         * Parse API response
         * @param {Object} data
         * @returns {*|string}
         */
        parse: function (data) {
            return data.data;
        },

        /**
         * Initialize
         */
        initialize: function (options) {
            this.url = options.apiUrl;
            this.model = ws.models.cartTableProduct;
        },

        /**
         * Override default sync() to append CSRF toke to requests
         * @param {string} method
         * @param {Object} model
         * @param {Object} options
         * @returns {*}
         */
        sync: function (method, model, options) {
            options = options || {};
            options.url = this.url;
            return Backbone.sync.apply(this, [method, model, options]);
        }

    });
})(westcon);
